export default {
  asyncRecursive(func: Function, time: number) {
    let timerId: number | undefined;
    let isTimerCanceled: boolean = false;

    return {
      async run(...args: any[]) {
        try {
          await func(...args);
        } catch (e) {

        }

        timerId = setTimeout(timeout, time, ...args);
      },
      cancel() {
        isTimerCanceled = true;

        clearTimeout(timerId);
      }
    };

    async function timeout(...args: any[]) {
      try {
        await func(...args);
      } catch (e) {

      }

      if (!isTimerCanceled) {
        timerId = setTimeout(timeout, time, ...args);
      }
    }
  }
}
